import type { ProjectDto } from '@/services/types/api.types';
import { useCommunityStore } from '@/stores';
import { computed, unref, type ComputedRef, type MaybeRef } from 'vue';

export const useResolvedProjectThemeKey = (project: MaybeRef<ProjectDto | undefined | null>): ComputedRef<string> => {
  const communityStore = useCommunityStore();

  return computed(() => {
    const projectThemeKey = unref(project)?.theme_key ?? undefined;
    return projectThemeKey ?? communityStore.community?.default_project_theme_key ?? 'default';
  });
};
